import script from "./callback.vue?vue&type=script&setup=true&lang=ts"
export * from "./callback.vue?vue&type=script&setup=true&lang=ts"

import "./callback.vue?vue&type=style&index=0&id=0d6e74a7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6e74a7"]])

export default __exports__